(function (ws) {
    'use strict';

    ws.views.MagicTable = Backbone.View.extend({

        /**
         * Extend Options
         */
        options: {},

        /**
         * Initialize
         */
        initialize: function () {
            this.$container = this.$el.parent();

            // Render
            this.getColumns();
            this.render();

            // Auto Resize
            $(window).resize(this.autoResize.bind(this));
        },

        /**
         * Render
         */
        render: function () {
            this.table = new Handsontable(this.$el.get(0), _.extend({
                data: this.data,
                columns: this.columns,
                stretchH: 'all',
                colHeaders: this.colHeaders,
                manualColumnResize: true, //allow columns to be resized
                columnSorting: false,
                fillHandle: {
                    direction: 'vertical', //allow drag-down and copy-down functionality only vertically
                    autoInsertRow: false
                },
                manualColumnMove: true,
                manualRowMove: true,
                renderAllRows: false,
                rowHeights: 42,
                columnHeaderHeight: 42,
                licenseKey: 'bcf78-c247f-c7d42-54b3c-96c5f'
            }, this.options));
            this.setHeight();
            this.checkPriceProtectionDate();
        },

        checkPriceProtectionDate: function () {
            let error = false;
            this.data.forEach(element => {
                if (moment(element.priceProtectionDate, dateFormat).isBefore(new Date(), 'date')) {
                    error = true;
                }
            });

            if (error) {
                $('.price-protection-warning').removeClass('hide');
            }
        },

        /**
         * Auto Resize
         */
        autoResize: function () {
            this.table.updateSettings({
                width: this.$container.width()
            });
        },

        /**
         * Set Height
         */
        setHeight: function () {
            var getHeight = this.$el.find('table.htCore').outerHeight() + (globals.isWindows() ? 20 : 0);
            if (this.$el.hasClass('quotePricingTableCls') || this.$el.hasClass('quoteVrfTableCls')) {
                getHeight =  $('.ht_master .wtHider').height() < 450 ? $('.ht_master .wtHider').height() + 70 : 500;
            }

            this.table.updateSettings({
                height: getHeight
            });
        },

        /**
         * Refresh and ReRender the Table
         */
        refresh: function () {
            this.table.render();
            this.setHeight();
        },

        /**
         * Get Columns
         */
        getColumns: function () {
            _.each(this.columns, function (column, i) {
                this.columns[i] = _.extend(column, {
                    data: this.attr(column.data)
                });
            }.bind(this));
        },

        /**
         * Get Model Attribute Data
         * @param {string} attr
         * @returns {Function}
         */
        attr: function (attr) {
            /**
             * Return Function
             */
            return function (car, value) {
                if (_.isUndefined(value)) {
                    return car.get(attr);
                }

                car.set(attr, value);
            };
        }

    });
})(westcon);
